export const CLEAR = 'CLEAR';
export const ERROR = 'ERROR';
export const CWA_STATUS = 'CWA_STATUS';
